module.exports = __webpack_public_path__ + "490c50b0d14fa9dfb7992b95eff6a552.png";


//////////////////
// WEBPACK FOOTER
// ./Res/3rd/hausplanner/img/empty_img.png
// module id = 2586
// module chunks = 1